import { getBrandId } from '../../../tenants/common/bought-this-season/brand-org';

export const POCKETS_LOOK_AHEAD_PROVIDER_PROPERTIES = {
  daysIntoTheFuture: 9,
  daysIntoThePast: 7,
  shipToAddressId: null,
  filterMissingImages: null,
  brandId: getBrandId(),
};
